import { RootState } from "shared/config/store"

export const getFileVersionsFileIdSelector = (state: RootState) => state.fileVersions.nodeId

export const getFileVersionsStatusSelector = (state: RootState) => state.fileVersions.status

export const getFileVersionsSelectedVersionIdSelector = (state: RootState) => state.fileVersions.selectedVersion

export const getFileVersionsItemsSelector = (state: RootState) => state.fileVersions.versions